'use client';

import { SectionHeader, SectionLayout, Spacing } from '@kezios/design-system';
import { Stack } from '@mantine/core';
import { TERMS_OF_SERVICE } from 'consts/tos.consts';
import { useTranslations } from 'next-intl';

export const TermsOfServicePage = () => {
  const t = useTranslations('page.tos');

  return (
    <SectionLayout>
      <Stack pb={Spacing.s24}>
        <SectionHeader
          category={t('category')}
          title={t('title')}
          subtitle={t('subtitle')}
        />
        <div dangerouslySetInnerHTML={{ __html: TERMS_OF_SERVICE }} />
      </Stack>
    </SectionLayout>
  );
};
